/**
 * State used to represent a failure of the lookup service
 * @param error type to display.
 * @param onConfirm callback of type () => to invoke when the user confirms.
 */
define([], () => ({error, onConfirm}) => {
    return {
        get error() { return error; },
        confirm() { onConfirm(); }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/models/LookupFailureState.js
 **/